import PropTypes from 'prop-types'
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import useDataFetching from '../../../../../hooks/useDataFetching'
import InventoryZonesRepository from '../../../../../repositories/InventoryZonesRepository'
import {
  INVENTORY_ZONES_ADD_LINK,
  INVENTORY_ZONES_EDIT_LINK
} from '../../../../../routes/masterLayoutRoutes/InventoryZonesRoutes'
import { BreadCrumb } from '../../../../common/breadCrumb'
import { ItemList } from '../../../../common/list'
import CustomSimpleCellFormatter from '../../../../common/list/CustomSimpleCellFormatter'

const InventoryZoneList = props => {
  const {
    data: inventoryZones,
    totalCount,
    page,
    totalPages,
    isLoading,
    onSearch,
    onPageChange,
    qsParams,
    setQsParams
  } = useDataFetching(InventoryZonesRepository, {
    orderBy: 'inventoryZoneName',
    orderDirection: 'asc'
  })

  const history = useHistory()

  const rows = inventoryZones.map(
    ({ inventoryZoneName = '', description = '', PK, totalProducts }) => {
      const editUrl = `${INVENTORY_ZONES_EDIT_LINK}/${PK}`
      const editBtn = (
        <Button
          primary
          as={Link}
          to={editUrl}
          icon='pencil'
          size='mini'
          content='Edit'
        />
      )
      return {
        inventoryZoneName,
        description,
        editUrl,
        totalItems: totalProducts,
        editBtn
      }
    }
  )

  return (
    <ItemList
      breadCrumb={<BreadCrumb route={props.route} />}
      columns={[
        { key: 'inventoryZoneName', name: 'Name', width: 500, sortable: true },
        { key: 'description', name: 'Description', sortable: true },
        { key: 'totalItems', name: 'Items Included', sortable: true },
        {
          key: 'editBtn',
          width: 110,
          formatter: CustomSimpleCellFormatter
        }
      ]}
      isLoading={isLoading}
      rows={rows}
      rowCount={rows.length}
      totalRows={totalCount}
      onPageChanged={onPageChange}
      activePage={page}
      totalPages={totalPages}
      onSortChanged={(sortColumn, sortDirection) => {
        if (sortDirection === 'NONE') {
          setQsParams({
            ...qsParams,
            orderBy: 'id',
            orderDirection: 'ASC'
          })
          return rows
        }
        setQsParams({
          ...qsParams,
          orderBy: sortColumn,
          orderDirection: sortDirection
        })
        return rows
      }}
      onSearch={onSearch}
      onRowDoubleClick={index => {
        history.push(rows[index].editUrl)
      }}
      addLink={INVENTORY_ZONES_ADD_LINK}
    />
  )
}

InventoryZoneList.propTypes = {
  route: PropTypes.any
}

export default InventoryZoneList
